import request from '@/util/request'
import store from '../store/store'

// 设备服务期开放体验白名单手机号（与 addDevice.vue 保持一致）
export const SERVICE_PLAN_ALLOWED_PHONES = [
  '18676738514',
  '13760203721',
  '13829597323',
  '13682300127',
  '15305626610',
  '13760286454',
  '18112545657',
  '18025366812'
]

// 判断指定用户或当前登录用户是否在白名单内
export function isServicePlanAllowed (user) {
  let phone = user || (store.getters && store.getters.get_user)
  return SERVICE_PLAN_ALLOWED_PHONES.indexOf(phone) !== -1
}

// 查询当前用户所有设备的服务期列表（4G、WiFi、NB全部设备统一平台年费）
export function queryUserServicePlans (params = {}) {
  let token = store.getters.get_token
  return request({
    url: '/user/serviceplans',
    method: 'get',
    params: { token: token, ...params }
  })
}

// 调试模拟续费接口（顺延 1 年服务期）
export function mockRenewServicePlan (did) {
  let token = store.getters.get_token
  return request({
    url: '/user/serviceplan/mock_renew',
    method: 'post',
    params: { token: token },
    data: { did: did }
  })
}

// 创建设备服务费微信预支付订单（标价36元/年，测试实扣0.01元）
export function createServicePlanWechatOrder (data) {
  let token = store.getters.get_token
  return request({
    url: '/user/serviceplan/wechat_order',
    method: 'post',
    params: { token: token },
    data: data
  })
}

// 主动核验设备服务费微信订单支付状态
export function queryServicePlanOrderIsOk (data) {
  let token = store.getters.get_token
  return request({
    url: '/user/serviceplan/query_order',
    method: 'post',
    params: { token: token },
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/servicePlan.js